module.exports = __webpack_public_path__ + "rijksoverheidsanstext-regular_2_0.woff?1a6e41bba2709c9ef33d0b66c9bee7b0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rijksoverheidsanstext-regular_2_0.woff
// module id = 548
// module chunks = 0